module.exports = __webpack_public_path__ + "static/media/phone.c072a36f.png";


//////////////////
// WEBPACK FOOTER
// ./src/phone.png
// module id = 257
// module chunks = 0